module.exports = __webpack_public_path__ + "static/14-c790c0ef0a4361e8083cf2acc81b7f4e.mp4";